import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Button,
  DateTimePicker,
  FileSelector,
  Option,
  Picklist,
  Textarea,
} from "react-rainbow-components";
import { Link } from "react-router-dom";
import ShowNotification from "../shared/Notification";
import { useHistory } from "react-router";
import { DefaultDateTime } from "../shared/DateTime";
import { DateTimeFormatter } from "../shared/DateTimeFormatter";
import { RequestInit } from "../shared/RequestInit";

const CreatePodcast = () => {
  const [Titre, setTitre] = useState<string>("");
  const [Podcast, setPodcast] = useState<Blob | string>("");
  const [UploadePodcast, setUploadePodcast] = useState<string>("");
  const [Date_Debut, setDate_Debut] = useState<string>(DefaultDateTime);
  const [UploadeImage, setUploadeImage] = useState<string>("");
  const [Image, setImage] = useState<Blob | string>("");
  const [Description, setDescription] = useState<string>("");

  const [errorTitre, setErrorTitre] = useState<string>("");
  const [errorDescription, setErrorDescription] = useState<string>("");
  const [errorPodcast, setErrorPodcast] = useState<string>("");
  const [UploadError, setUploadError] = useState<boolean>(false);
  const [errorImage, setErrorImage] = useState<string>("");
  const [EmissionError, setEmissionError] = useState<string>("");
  const [pending, setPending] = useState<boolean>(false);

  const [DropdownState, setDropdownState] = useState<any>({
    name: "",
    label: "",
  });

  const [DropDown, setDropDown] = useState<[]>([]);
  const [Emission, setEmission] = useState<any>({
    name: "",
    label: "",
  });

  const [loading, setLoading] = useState<boolean>(false);

  const history = useHistory();

  const resetInputErrors = () => {
    setUploadError(false);
    setErrorTitre("");
    setErrorPodcast("");
    setErrorImage("");
    setErrorDescription("");
    setEmissionError("");
  };
  const verifyInput = () => {
    /* initial */
    let isGood: boolean = true;
    if (Titre === "") {
      setErrorTitre("Le titre est obligatoire");
      isGood = false;
    }
    if (Description === "") {
      setErrorDescription("La description est obligatoire");
      isGood = false;
    }
    if (Podcast === "") {
      setErrorPodcast(`Le fichier .mp3 est obligatoire`);
      isGood = false;
    }
    if (Image === "") {
      setErrorImage(`L'image est obligatoire`);
      isGood = false;
    }
    if (Emission.Id === undefined) {
      setEmissionError(`L'emission est obligatoire`);
      isGood = false;
    }
    /* if required fields are not empty, return true otherwise return false */
    if (isGood) {
      return true;
    } else {
      return false;
    }
  };

  const fetchtDropDown = async () => {
    await fetch(
      "https://admin.radioemotion.be/api/emission/dropdown",
      RequestInit as RequestInit
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response === true) {
          console.log(response.data);
          setDropDown(response.data);
          setPending(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPending(false);
      });
  };
  const CreateActualite = () => {
    resetInputErrors();
    if (verifyInput() === true) {
      const sendDate = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("audio", Podcast);
        formData.append("file", Image);
        formData.append(
          "data",
          JSON.stringify({
            Titre: Titre,
            Description: Description,
            Date_enregistrement: Date_Debut,
            EMISSION_FK: Emission.Id,
          })
        );
        const requestOptions = {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        };
        await fetch(
          "https://admin.radioemotion.be/api/podcast/create",
          requestOptions as RequestInit
        )
          .then((response) => response.json())
          .then((response) => {
            setLoading(false);
            if (response.response === true) {
              history.push({
                pathname: "/",
                state: { passed: true, message: `Le podcast a été créé` },
              });
            } else {
              setUploadError(true);
            }
          })
          .catch((err) => {
            setLoading(false);
            setUploadError(true);
          });
      };
      sendDate();
    }
  };
  useEffect(() => {
    fetchtDropDown();
  }, []);

  return (
    <>
      {UploadError ? (
        <>
          <ShowNotification
            icon="times"
            iconClassName="color-red"
            bodyClassName="color-red background-color-red text-white"
            autohide={5000}
            title=""
            message="Une erreur s'est produite"
            text="maintenant"
          />
        </>
      ) : null}
      <MDBContainer className="min-h-100vh">
        <MDBRow className="mb-5 mt-2">
          <Link to="/">
            <Button variant="neutral" className="mt-2">
              <FontAwesomeIcon icon={faHome} className="py-1" size="2x" />
            </Button>
          </Link>
        </MDBRow>
        <MDBRow>
          <form encType="multipart/form-data" className="w-100">
            <MDBRow around>
              <MDBCol md={"6"} xs={"12"} sm={"12"}>
                <Textarea
                  id="podcastCreateTitre"
                  label="Titre du podcast"
                  rows={2}
                  placeholder="Titre du podcast"
                  grow={true}
                  onChange={(e) => {
                    setTitre(e.target.value);
                    {
                      e.target.value === ""
                        ? setErrorTitre("Le titre est obligatoire")
                        : setErrorTitre("");
                    }
                  }}
                  value={Titre}
                  error={errorTitre}
                />
              </MDBCol>
              <MDBCol md={"6"} xs={"12"} sm={"12"}>
                <Textarea
                  id="podcastCreateDescription"
                  label="Description du podcast"
                  rows={2}
                  placeholder="Description du podcast"
                  grow={true}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    {
                      e.target.value === ""
                        ? setErrorDescription("La description est obligatoire")
                        : setErrorDescription("");
                    }
                  }}
                  value={Description}
                  error={errorDescription}
                />
              </MDBCol>
            </MDBRow>
            <MDBRow around className="mt-5">
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <DateTimePicker
                  value={Date_Debut}
                  label="Date du Podcast"
                  locale="fr"
                  formatStyle={"large"}
                  onChange={(value) =>
                    setDate_Debut(DateTimeFormatter(value, true))
                  }
                  hour24={true}
                />
              </MDBCol>
              <MDBCol md={"4"} className="">
                <Picklist
                  placeholder="Nom de l'emission"
                  label="Nom de l'emission"
                  name="Nom de l'emission"
                  variant="default"
                  value={DropdownState}
                  error={EmissionError}
                  onChange={(value) => {
                    setDropdownState({
                      name: value.label,
                      label: value?.value,
                    });
                    setEmission({ Id: value.name });
                  }}
                >
                  {DropDown &&
                    DropDown.map(
                      (
                        data: { Id: number; emission: string; jour: string },
                        index: number
                      ) => (
                        <Option
                          key={index}
                          name={`${data.Id}`}
                          label={`${data.emission}`}
                          value={`${data.emission}`}
                        />
                      )
                    )}
                </Picklist>
              </MDBCol>
            </MDBRow>
            <MDBRow center className="mt-5">
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <FileSelector
                  label="Fichier mp3 du podcast"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setPodcast(value[0]);
                    setUploadePodcast(URL.createObjectURL(value[0]));
                  }}
                  accept=".mp3"
                  error={errorPodcast}
                />
              </MDBCol>
              <MDBCol md={"4"} xs={"12"} sm={"12"}>
                <FileSelector
                  label="Pochette du podcast"
                  placeholder="Glisser & déposer ou cliquer pour parcourir"
                  bottomHelpText="Selectionez seulement un fichier"
                  onChange={(value) => {
                    setImage(value[0]);
                    setUploadeImage(URL.createObjectURL(value[0]));
                  }}
                  error={errorImage}
                />
              </MDBCol>
            </MDBRow>
          </form>
        </MDBRow>
        <MDBRow end>
          <Button
            isLoading={loading}
            label="Créer"
            onClick={() => CreateActualite()}
            variant="brand"
            className="mt-2 mb-4 font-weight-bold"
          />
        </MDBRow>
      </MDBContainer>
    </>
  );
};

export default CreatePodcast;
